var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbol24(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.66,
    height: 20.647,
    viewBox: "0 0 20.66 20.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d{fill:none;}.b{clip-path:url(#a);}.c,.d{stroke:#aa0100;stroke-linecap:round;stroke-width:1.5px;}.c{stroke-linejoin:round;}.d{stroke-linejoin:bevel;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.66,
    height: 20.647
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2203.046,834.979v-3.186",
    transform: "translate(2205.62 -831.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2203.046,919.04V908.215",
    transform: "translate(2205.62 -899.893)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 2.571,
    cy: 2.568,
    rx: 2.571,
    ry: 2.568,
    transform: "translate(0 3.188)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.76 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2141.187,842.252V831.793",
    transform: "translate(2143.761 -831.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2141.187,978.55V975",
    transform: "translate(2143.761 -959.403)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 2.571,
    cy: 2.568,
    rx: 2.571,
    ry: 2.568,
    transform: "translate(0 10.46)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.769 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2032.12,835.608v-5.442",
    transform: "translate(2034.694 -830.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2032.12,935.866V927.3",
    transform: "translate(2034.694 -916.719)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 2.571,
    cy: 2.568,
    rx: 2.571,
    ry: 2.568,
    transform: "translate(0 5.443)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol24);
export default __webpack_public_path__ + "static/media/Symbol 24.a2ce060dd31eb9499890ec437ac3691c.svg";
export { ForwardRef as ReactComponent };